'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = require('./index');

var _DiffusionSession = require('../DiffusionSession');

var _DiffusionSession2 = _interopRequireDefault(_DiffusionSession);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DIFFUSION_IDLE_TIMEOUT = 1000 * 60 * 60; // 1hr timeout

var IdleTimer = function () {
    function IdleTimer() {
        _classCallCheck(this, IdleTimer);

        console.log('idleTimer: is enabled', window.isDiffusionIdleTimerEnabled);
        this.isEnabled = window.isDiffusionIdleTimerEnabled;
        this.timer = null;
        this.session = null;
        this.isSubscribed = false;
        this.config = null;
        this.activeSubscriptions = new Map();
        this.closedSubscriptions = new Map();

        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.closeDiffusionSession = this.closeDiffusionSession.bind(this);
        this.stop = this.stop.bind(this);
    }

    _createClass(IdleTimer, [{
        key: 'init',
        value: function init(session, config) {
            if (this.isEnabled) {
                this.session = session;
                this.isSubscribed = true;
                this.config = config;
                window.addEventListener('blur', this.onBlur);
                window.addEventListener('focus', this.onFocus);
            }
        }
    }, {
        key: 'onBlur',
        value: function onBlur() {
            var _this = this;

            this.timer = window.setTimeout(function () {
                return _this.closeDiffusionSession();
            }, DIFFUSION_IDLE_TIMEOUT);
        }
    }, {
        key: 'onFocus',
        value: function onFocus() {
            if (this.timer) {
                window.clearTimeout(this.timer);
                this.timer = null;
            }
            if (!this.isSubscribed) {
                this.reconnectToDiffusion();
            }
        }
    }, {
        key: 'closeDiffusionSession',
        value: function closeDiffusionSession() {
            var _this2 = this;

            if (this.isEnabled) {
                this.isSubscribed = false;

                if (this.session) {
                    console.log('idleTimer: disconnecting from diffusion');
                    this.closedSubscriptions = this.activeSubscriptions;
                    this.activeSubscriptions = new Map();

                    this.session.closeConnection();

                    setTimeout(function () {
                        var connector = (0, _index.getConnector)();
                        if (connector && connector.clearTopicStoreSession) {
                            connector.clearTopicStoreSession();
                        }
                        _this2.session = null;
                        window.clearTimeout(_this2.timer);
                        _this2.timer = null;
                    }, 500);
                }
            }
        }
    }, {
        key: 'reconnectToDiffusion',
        value: function reconnectToDiffusion() {
            if (this.isEnabled) {
                console.log('idleTimer: reconnecting to diffusion');
                this.stop();
                this.session = new _DiffusionSession2.default(this.config);
                this.isSubscribed = true;
                this.session.subscribe({
                    topics: Array.from(this.closedSubscriptions.values()).map(function (item) {
                        return item.feed;
                    })
                });
                this.closedSubscriptions = new Map();
            }
        }
    }, {
        key: 'stop',
        value: function stop() {
            window.clearTimeout(this.timer);
            this.session = null;
            this.timer = null;
            window.removeEventListener('blur', this.onBlur);
            window.removeEventListener('focus', this.onFocus);
        }
    }]);

    return IdleTimer;
}();

var idleTimer = new IdleTimer();
exports.default = idleTimer;


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/connector/idleTimer.js
// module id = 675
// module chunks = 1